<!--
***********************
***** PLEASE READ *****
***********************
This component contains three sections with the first being for the Digital/web version.
The second and third are for the print PDF version.
If any generic amends are made, please check and ensure they are made to both sections if required.
-->

<!-- Start: Digital/Web page only -->
@if (!isPrintPDFRoute) {
  <section class="section section--added-extras">
    <div class="container">
      <h2 [innerText]="'Your added extras.' | translate" class="secondary-heading"></h2>
      <h3 [innerText]="'You mean more to us than money.' | translate"
      class="tertiary-heading tertiary-heading--white"></h3>
      <mat-tab-group class="nav nav-tabs nav-tabs--white" disableRipple>
        @for (category of categories; track trackByFn($index, category)) {
          <mat-tab>
            <ng-template mat-tab-label>
              <span [innerHTML]="category" class="hide-for-print"></span>
            </ng-template>
            <div class="row mx-0 justify-content-center">
              @for (reward of addedExtraRewards.categoryRewards; track reward) {
                @if (category === 'All' || (reward.categories || []).indexOf(category) > -1) {
                  <div
                    class="col-xs-12 col-sm-6 col-lg-4 col-xl-3 added-extras-print-layout">
                    <div class="added-extras-tile">
                      <h4 [innerText]="reward.name" class="quaternary-heading hide-for-print"></h4>
                      <div class="print-only">
                        <h2 [innerText]="reward.name" class="print-only__secondary-heading"></h2>
                        @if (reward.longDescriptionDigital) {
                          <p
                          [innerText]="reward.longDescriptionDigital"></p>
                        }
                      </div>
                      <button (click)="openModal(template)"
                        class="btn btn-primary btn--added-extras"><span [innerText]="'Learn more' | translate"></span> <span
                      class="visually-hidden"> {{ 'about' | translate }} {{ reward.name }}</span></button>
                      <ng-template #template>
                        <div class="modal-header">
                          <h2 [innerText]="reward.name + '.'"
                          class="secondary-heading secondary-heading--modal pull-left"></h2>
                        </div>
                        <div class="modal-body">
                          @if (reward.longDescriptionDigital) {
                            <p
                            [innerText]="reward.longDescriptionDigital"></p>
                          }
                        </div>
                        <button (click)="modalRef.hide()" aria-label="Close" class="modal__close pull-right"
                          type="button">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </ng-template>
                    </div>
                  </div>
                }
              }
            </div>
          </mat-tab>
        }
      </mat-tab-group>
    </div>
  </section>
}
<!-- End: Digital/Web page only -->

<!-- Start: PDF print only -->
@if (isPrintPDFRoute) {
  <!-- Page 1 -->
  <section class="section section--added-extras pdf-page-wrapper">
    <h2 [innerText]="'Your added extras.' | translate" class="secondary-heading"></h2>
    <h3 [innerText]="'You mean more to us than money. ' | translate"
    class="tertiary-heading tertiary-heading--white"></h3>
    <div class="row justify-content-center">
      <!-- We only need to loop over the first item from the array which is Category All so using 'first' -->
      @if (getAddedExtrasLengthForPdf > 1) {
        <div class="pdf-print-column">
          @for (extra of addedExtraRewards.categoryRewards; track trackByFn(extraIndex, extra); let extraIndex = $index) {
            @if (extraIndex < 2) {
              <ng-container
              *ngTemplateOutlet="extrasTemplate; context:{ $implicit: extra, idx: extraIndex }"></ng-container>
            }
          }
        </div>
      }
      @if (getAddedExtrasLengthForPdf > 2) {
        <div class="pdf-print-column pdf-print-column--left-border">
          @for (extra of addedExtraRewards.categoryRewards; track trackByFn(extraIndex, extra); let extraIndex = $index) {
            @if (extraIndex > 1 && extraIndex < 4) {
              <ng-container
              *ngTemplateOutlet="extrasTemplate; context:{ $implicit: extra, idx: extraIndex }"></ng-container>
            }
          }
        </div>
      }
      @if (getAddedExtrasLengthForPdf > 4) {
        <div class="pdf-print-column pdf-print-column--left-border">
          @for (extra of addedExtraRewards.categoryRewards; track trackByFn(extraIndex, extra); let extraIndex = $index) {
            @if (extraIndex > 3 && extraIndex < 6) {
              <ng-container
              *ngTemplateOutlet="extrasTemplate; context:{ $implicit: extra, idx: extraIndex }"></ng-container>
            }
          }
        </div>
      }
    </div>
  </section>
  <!-- End of page 1 -->
  <!-- Page 2 (if user has more than 6 rewards) -->
  @if (isPageTwoNeededForPdf) {
    <section class="section section--added-extras section--pdf-page-2 pdf-page-wrapper">
      <h2 [innerText]="'Your added extras.' | translate" class="secondary-heading"></h2>
      <div [innerText]="'(continued)' | translate" class="pdf-page2-continued"></div>
      <div class="row justify-content-center">
        @if (getAddedExtrasLengthForPdf > 6) {
          <div class="pdf-print-column">
            @for (extra of addedExtraRewards.categoryRewards; track trackByFn(extraIndex, extra); let extraIndex = $index) {
              @if (extraIndex > 5 && extraIndex < 8) {
                <ng-container
                *ngTemplateOutlet="extrasTemplate; context:{ $implicit: extra, idx: extraIndex }"></ng-container>
              }
            }
          </div>
        }
        @if (getAddedExtrasLengthForPdf > 8) {
          <div class="pdf-print-column pdf-print-column--left-border">
            @for (extra of addedExtraRewards.categoryRewards; track trackByFn(extraIndex, extra); let extraIndex = $index) {
              @if (extraIndex > 7 && extraIndex < 10) {
                <ng-container
                *ngTemplateOutlet="extrasTemplate; context:{ $implicit: extra, idx: extraIndex }"></ng-container>
              }
            }
          </div>
        }
        <!-- If the user only has one time reward we add it as an Added Extra so catering for a potential 11th reward. -->
        @if (getAddedExtrasLengthForPdf > 10) {
          <div class="pdf-print-column pdf-print-column--left-border">
            @for (extra of addedExtraRewards.categoryRewards; track trackByFn(extraIndex, extra); let extraIndex = $index) {
              @if (extraIndex > 9 && extraIndex < 11) {
                <ng-container
                *ngTemplateOutlet="extrasTemplate; context:{ $implicit: extra, idx: extraIndex }"></ng-container>
              }
            }
          </div>
        }
      </div>
    </section>
  }
  <!-- End of page 2 -->
}

<!-- Added extras block template reused in print pdf columns above-->
<ng-template #extrasTemplate let-extra let-index="idx">
  <div class="block block--rank-{{index + 1}}">
    <div class="block__content">
      <h4 [innerText]="extra.name" class="quaternary-heading"></h4>
      <p [innerText]="extra.shortDescriptionPrint"></p>
    </div>
  </div>
</ng-template>
<!-- End: PDF print only -->
